(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid-dynamic"] && !Shopify.designMode) return;
  try {
    
// Scoped, versioned navigation; links still work without JavaScript.
if (!customElements.get('weone-category-navigation-v5')) {
  customElements.define('weone-category-navigation-v5', class extends HTMLElement {
    connectedCallback() {
      if (this.eventController) return;
      this.eventController = new AbortController();
      const signal = this.eventController.signal;
      this.activeControlId = null;
      this.activeChildControlId = null;
      this.lastUiClick = null;
      this.lastEditorSelect = null;
      this.layoutFrame = null;

      this.addEventListener('click', event => this.handleClick(event), { signal });
      this.addEventListener('keydown', event => this.handleKeydown(event), { signal });
      document.addEventListener('shopify:block:select', event => this.handleEditorSelect(event), { signal });
      window.addEventListener('resize', () => this.scheduleLayout(), { passive: true, signal });

      this.refreshControls();
      this.contentObserver = new MutationObserver(() => this.refreshControls());
      this.contentObserver.observe(this, { childList: true, subtree: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
        this.resizeObserver.observe(this);
      }
      if (document.fonts) {
        document.fonts.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
        document.fonts.addEventListener('loadingdone', () => this.scheduleLayout(), { signal });
      }
      this.scheduleLayout();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.layoutFrame);
      if (this.contentObserver) this.contentObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.eventController) this.eventController.abort();
      this.eventController = null;
      this.layoutFrame = null;
    }

    refreshControls() {
      this.list = this.querySelector('[data-category-list]');
      this.rail = this.querySelector('.category-rail');
      this.panelHost = this.querySelector('.category-subpanels');
      this.controls = Array.from(this.querySelectorAll('[data-category-control]'));
      this.allPanels = Array.from(this.querySelectorAll('[data-category-panel]'));
      this.allPages = Array.from(this.querySelectorAll('[data-category-page]'));
      this.childControls = Array.from(this.querySelectorAll('[data-subcategory-control]'));
      const panelById = new Map(this.allPanels.map(panel => [panel.id, panel]));
      const pageById = new Map(this.allPages.map(page => [page.id, page]));
      this.panelByControlId = new Map();
      this.pageByChildId = new Map();
      this.controls.forEach(control => {
        const panel = panelById.get(control.dataset.categoryPanelId);
        if (panel) {
          this.panelByControlId.set(control.id, panel);
          control.setAttribute('role', 'button');
          control.setAttribute('aria-controls', panel.id);
        } else {
          control.removeAttribute('role');
          control.removeAttribute('aria-controls');
          control.removeAttribute('aria-expanded');
        }
      });
      this.childControls.forEach(control => {
        const page = pageById.get(control.dataset.subcategoryPageId);
        if (page && page.closest('[data-category-panel]') === control.closest('[data-category-panel]')) {
          this.pageByChildId.set(control.id, page);
          control.setAttribute('role', 'button');
          control.setAttribute('aria-controls', page.id);
        } else {
          control.removeAttribute('role');
          control.removeAttribute('aria-controls');
          control.removeAttribute('aria-expanded');
        }
      });
      if (!this.panelByControlId.has(this.activeControlId)) this.activeControlId = null;
      if (!this.pageByChildId.has(this.activeChildControlId)) this.activeChildControlId = null;
      this.renderState();
    }

    renderState() {
      const activePanel = this.panelByControlId.get(this.activeControlId);
      const childPage = this.pageByChildId.get(this.activeChildControlId);
      if (!activePanel || !childPage || childPage.closest('[data-category-panel]') !== activePanel) {
        this.activeChildControlId = null;
      }
      const activePage = this.pageByChildId.get(this.activeChildControlId) ||
        (activePanel && activePanel.querySelector('[data-root-page]'));
      this.allPanels.forEach(panel => { panel.hidden = panel !== activePanel; });
      if (this.panelHost) this.panelHost.hidden = !activePanel;
      this.allPages.forEach(page => { page.hidden = page !== activePage; });
      this.controls.forEach(control => {
        const open = control.id === this.activeControlId && Boolean(activePanel);
        control.classList.toggle('is-active', open);
        if (this.panelByControlId.has(control.id)) control.setAttribute('aria-expanded', String(open));
      });
      this.childControls.forEach(control => {
        if (this.pageByChildId.has(control.id)) {
          control.setAttribute('aria-expanded', String(control.id === this.activeChildControlId));
        }
      });
      this.updateLayout();
    }

    ownedClosest(target, selector) {
      const element = target instanceof Element ? target : target && target.parentElement;
      const found = element && element.closest(selector);
      return found && found.closest('weone-category-navigation-v5') === this ? found : null;
    }

    setOpen(control, toggle = false) {
      this.refreshControls();
      const id = control && this.panelByControlId.has(control.id) ? control.id : null;
      const next = toggle && this.activeControlId === id ? null : id;
      if (next !== this.activeControlId || next === null) this.activeChildControlId = null;
      this.activeControlId = next;
      if (control) this.revealControl(control);
      this.renderState();
    }

    openChild(control, moveFocus = true) {
      this.refreshControls();
      const page = this.pageByChildId.get(control.id);
      const activePanel = this.panelByControlId.get(this.activeControlId);
      if (!page || !activePanel || page.closest('[data-category-panel]') !== activePanel) return;
      this.activeChildControlId = control.id;
      this.renderState();
      // The clicked link is now hidden. Put focus on a visible way back.
      if (moveFocus) {
        const back = page.querySelector('[data-subcategory-back]');
        if (back) back.focus({ preventScroll: true });
      }
    }

    goBack(moveFocus = true) {
      const previous = this.childControls.find(control => control.id === this.activeChildControlId);
      this.activeChildControlId = null;
      this.renderState();
      if (moveFocus && previous) previous.focus({ preventScroll: true });
    }

    handleClick(event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const back = this.ownedClosest(event.target, '[data-subcategory-back]');
      if (back) { event.preventDefault(); this.goBack(); return; }
      const child = this.ownedClosest(event.target, '[data-subcategory-control]');
      if (child) {
        this.refreshControls();
        if (this.pageByChildId.has(child.id)) { event.preventDefault(); this.openChild(child); }
        return;
      }
      const control = this.ownedClosest(event.target, '[data-category-control]');
      if (!control) return; // View-all and leaf links navigate normally.
      this.refreshControls();
      if (!this.panelByControlId.has(control.id)) {
        this.setOpen(null);
        if (control.getAttribute('aria-disabled') === 'true') event.preventDefault();
        return;
      }
      event.preventDefault();
      const now = performance.now();
      const editorJustOpened = this.lastEditorSelect &&
        this.lastEditorSelect.id === control.id && now - this.lastEditorSelect.time < 350;
      this.lastUiClick = { id: control.id, time: now };
      this.lastEditorSelect = null;
      this.setOpen(control, !editorJustOpened);
    }

    handleEditorSelect(event) {
      const detail = event.detail || {};
      if (detail.load === true) return;
      if (detail.sectionId && String(detail.sectionId) !== this.dataset.sectionId) return;
      this.refreshControls();
      const control = detail.blockId
        ? this.controls.find(item => item.dataset.blockId === String(detail.blockId))
        : this.ownedClosest(event.target, '[data-category-control]');
      if (!control) return;
      const now = performance.now();
      if (this.lastUiClick && this.lastUiClick.id === control.id && now - this.lastUiClick.time < 350) return;
      this.lastEditorSelect = { id: control.id, time: now };
      this.setOpen(control, false);
    }

    handleKeydown(event) {
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      this.refreshControls();
      if (event.key === 'Escape' && this.activeControlId) {
        event.preventDefault();
        if (this.activeChildControlId) { this.goBack(); return; }
        const activeControl = this.controls.find(item => item.id === this.activeControlId);
        this.setOpen(null);
        if (activeControl) activeControl.focus({ preventScroll: true });
        return;
      }
      const child = this.ownedClosest(event.target, '[data-subcategory-control]');
      if (child && this.pageByChildId.has(child.id)) {
        if (event.key === ' ' || event.key === 'ArrowDown') {
          event.preventDefault(); this.openChild(child);
        }
        return;
      }
      const control = this.ownedClosest(event.target, '[data-category-control]');
      if (!control) return;
      if (event.key === ' ' && this.panelByControlId.has(control.id)) {
        event.preventDefault(); control.click(); return;
      }
      if (event.key === 'ArrowDown' && this.panelByControlId.has(control.id)) {
        event.preventDefault();
        this.setOpen(control, false);
        const page = this.panelByControlId.get(control.id).querySelector('[data-category-page]:not([hidden])');
        const first = page && page.querySelector('button, a[href]');
        if (first) first.focus({ preventScroll: true });
        return;
      }
      const focusable = this.controls.filter(item => item.hasAttribute('href') && item.getAttribute('aria-disabled') !== 'true');
      let next = focusable.indexOf(control);
      if (next < 0 || !this.list) return;
      const direction = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
      switch (event.key) {
        case 'ArrowRight': next = (next + direction + focusable.length) % focusable.length; break;
        case 'ArrowLeft': next = (next - direction + focusable.length) % focusable.length; break;
        case 'Home': next = 0; break;
        case 'End': next = focusable.length - 1; break;
        default: return;
      }
      event.preventDefault();
      focusable[next].focus({ preventScroll: true });
      this.revealControl(focusable[next]);
    }

    revealControl(control) {
      if (control) this.scheduleLayout();
    }

    scheduleLayout() {
      if (this.layoutFrame !== null || !this.isConnected) return;
      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = null;
        if (this.isConnected) this.updateLayout();
      });
    }

    isMobileGrid() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    placePanelHost(mobile, activeControl) {
      if (!this.panelHost || !this.list) return;

      // Insert the subcategory panel immediately after the visual row
      // that contains the selected category:
      //   mobile  = 3 categories per row
      //   desktop = 10 categories per row
      let reference = this.list;
      if (activeControl) {
        const index = this.controls.indexOf(activeControl);
        if (index >= 0) {
          const columns = mobile ? 3 : 10;
          const rowStart = Math.floor(index / columns) * columns;
          const rowEnd = Math.min(this.controls.length - 1, rowStart + columns - 1);
          reference = this.controls[rowEnd];
        }
      }

      if (reference.nextElementSibling === this.panelHost) return;
      const focused = this.panelHost.contains(document.activeElement) ? document.activeElement : null;
      reference.after(this.panelHost);
      if (focused && !focused.closest('[hidden]')) focused.focus({ preventScroll: true });
    }

    updateLayout() {
      if (!this.list || !this.controls) return;
      const mobile = this.isMobileGrid();
      const activePanel = this.panelByControlId.get(this.activeControlId);
      const activeControl = this.controls.find(control => control.id === this.activeControlId);
      this.placePanelHost(mobile, activeControl);
      if (!activePanel || !activeControl || activePanel.hidden) return;
      const inner = activePanel.querySelector('.category-subpanel-inner');
      const page = activePanel.querySelector('[data-category-page]:not([hidden])');
      const links = page && page.querySelector('.cat-sub-list');
      if (!inner || !links) return;
      if (mobile) {
        // Fixed two-column cards on mobile; do not use desktop width balancing.
        inner.style.width = '100%';
        links.style.width = '100%';
        inner.style.setProperty('--panel-x', '0px');
        const controlRect = activeControl.getBoundingClientRect();
        const innerRect = inner.getBoundingClientRect();
        inner.style.setProperty('--panel-radius-tl', controlRect.left <= innerRect.left + 8 ? '0px' : '8px');
        inner.style.setProperty('--panel-radius-tr', controlRect.right >= innerRect.right - 8 ? '0px' : '8px');
        return;
      }
      const panelRect = activePanel.getBoundingClientRect();
      if (panelRect.width < 1) return;
      const configuredLimit = parseFloat(getComputedStyle(this).getPropertyValue('--panel-max-width')) || 1000;
      const available = Math.min(panelRect.width, configuredLimit);
      const innerStyle = getComputedStyle(inner);
      const padding = (parseFloat(innerStyle.paddingLeft) || 0) + (parseFloat(innerStyle.paddingRight) || 0);
      const contentAvailable = Math.max(1, available - padding);
      const gap = parseFloat(getComputedStyle(links).columnGap) || 0;
      // Measure each original link, not cloned text. Recalculate after fonts/resizes.
      inner.style.width = `${available}px`;
      links.style.width = 'max-content';
      const widths = Array.from(links.children).map(item => Math.min(contentAvailable, item.getBoundingClientRect().width));
      if (!widths.length) return;
      const total = widths.reduce((sum, width) => sum + width, 0) + gap * (widths.length - 1);
      let target = Math.min(contentAvailable, total + 1);
      if (total > contentAvailable) {
        const countRows = capacity => {
          let rows = 1, used = 0;
          for (const width of widths) {
            const next = used > 0 ? used + gap + width : width;
            if (used > 0 && next > capacity + .01) { rows += 1; used = width; }
            else used = next;
          }
          return rows;
        };
        const requiredRows = countRows(contentAvailable);
        let low = Math.max(...widths), high = contentAvailable;
        for (let step = 0; step < 20; step += 1) {
          const middle = (low + high) / 2;
          if (countRows(middle) <= requiredRows) high = middle;
          else low = middle;
        }
        target = Math.min(contentAvailable, Math.ceil(high + 1));
      }
      const crumb = page.querySelector('.cat-breadcrumbs');
      const crumbWidth = crumb ? Math.min(contentAvailable, crumb.getBoundingClientRect().width) : 0;
      const controlRect = activeControl.getBoundingClientRect();
      const minContent = Math.max(0, Math.min(available, controlRect.width) - padding);
      target = Math.min(contentAvailable, Math.max(target, crumbWidth, minContent));
      inner.style.width = `${Math.min(available, target + padding)}px`;
      links.style.width = '100%';

      // Desktop: attach to the selected tab and clamp to the section edges.
      const groupWidth = inner.getBoundingClientRect().width;
      const anchor = controlRect.left + controlRect.width / 2 - panelRect.left;
      const offset = Math.max(0, Math.min(anchor - groupWidth / 2, panelRect.width - groupWidth));
      inner.style.setProperty('--panel-x', `${Math.round(offset * 2) / 2}px`);
      const groupLeft = panelRect.left + offset;
      const groupRight = groupLeft + groupWidth;
      inner.style.setProperty('--panel-radius-tl', controlRect.left <= groupLeft + 8 ? '0px' : '8px');
      inner.style.setProperty('--panel-radius-tr', controlRect.right >= groupRight - 8 ? '0px' : '8px');
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
